module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#filter",
      toString: function () {
        return this.url;
      }
    }